import React from 'react';
import { Flex, HStack, Box, IconButton, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import GlobalSearchBar from '../GlobalSearchBar';
import Logo from './Logo';
import UserAvatarMenu from './UserAvatarMenu';

export default function AppHeader({
  userData,
  avatarUrl,
  role,
  isHomePage,
  onLogout,
  onSearchOpen,
  onLanguageChange,
  isVi,
  notificationSlot,
}: {
  userData?: { id: number; fullName?: string; email?: string } | null;
  avatarUrl?: string;
  role: string;
  isHomePage: boolean;
  onLogout: () => void;
  onSearchOpen: () => void;
  onLanguageChange: (l: 'vi' | 'en') => void;
  isVi: boolean;
  notificationSlot?: React.ReactNode;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <Flex
      as="header"
      h="60px"
      align="center"
      justify="space-between"
      px={{ base: 2, md: 4 }}
      borderBottomWidth="1px"
      position="sticky"
      top="0"
      bg="white"
      zIndex={1000}
      boxShadow="sm"
      maxW="100%"
      w="100%"
      left="0"
      right="0"
    >
      <HStack spacing={{ base: 2, md: 3 }} minW={0} flex={1} overflow="hidden">
        <Box display={{ base: 'block', md: 'block' }} minW={0} overflow="hidden">
          <Logo />
        </Box>
      </HStack>

      {!isHomePage && (
        <Box flex={1} maxW="400px" mx={4} display={{ base: 'none', md: 'block' }}>
          <GlobalSearchBar size="sm" maxWidth="100%" showShortcut={true} />
        </Box>
      )}

      <HStack spacing={2} flexShrink={0}>
        {!isHomePage && (
          <IconButton
            aria-label={t('search.placeholder')}
            icon={<SearchIcon />}
            size="sm"
            variant="ghost"
            display={{ base: 'inline-flex', md: 'none' }}
            onClick={onSearchOpen}
          />
        )}

        {notificationSlot}

        <Menu placement="bottom-end">
          <MenuButton
            as={IconButton}
            size="sm"
            variant="ghost"
            aria-label={t('common.language')}
            icon={
              <Box as="span" fontSize="md">
                {t('common.languageIcon')}
              </Box>
            }
            flexShrink={0}
          />
          <MenuList>
            <MenuItem onClick={() => onLanguageChange('vi')} isDisabled={isVi}>
              {t('language.vietnameseWithFlag')}
            </MenuItem>
            <MenuItem onClick={() => onLanguageChange('en')} isDisabled={!isVi}>
              {t('language.englishWithFlag')}
            </MenuItem>
          </MenuList>
        </Menu>

        <UserAvatarMenu role={role} userData={userData} avatarUrl={avatarUrl} onLogout={onLogout} />
      </HStack>
    </Flex>
  );
}
